<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <b>ІПН:</b>
                <span>{{insured.identification_number}} </span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12">
                <b>ПІБ:</b>
                <span>{{insured.fio_en}} </span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'InsuredsListItem',
    props: ['insured'],
}

</script>
